import React from 'react'
import './WiCalculator.css'
import Axios from 'axios';
import { useAuth } from "../Context/AuthContext";

const WiCalculator = () => {
    const { appUser, setUser, isLogin, setLogin } = useAuth();
    async function calculateWaterIntake() {
        var bodyWeight = document.getElementById("bodyWeight").value;

        if (bodyWeight === "" || isNaN(bodyWeight)) {
            alert("Please enter a valid body weight.");
            return;
        }

        var waterIntake = bodyWeight * 0.033;
        try{
            const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/saveftdata',{'userEmail':appUser.email,'toolName':'RequiredWaterIntake','toolValue':waterIntake.toFixed(2)});
            console.log(response);
        }catch(error){
            console.log(error);
        }
        document.getElementById("result").innerHTML = "Your recommended daily water intake is approximately " + waterIntake.toFixed(2) + " liters.";
        document.getElementById('result-container').style.display='flex';
    }
    return (
        <div className='water-intake-container'>
            <div className='input-container'>
                <label>Enter your body weight (kg):</label>
                <input type="number" id="bodyWeight" placeholder="Enter your weight in kg" />
            </div>
            <button className='calculate-btn' onClick={()=>{calculateWaterIntake()}}>Calculate</button>
            <div id='result-container' className='result' style={{display:'none'}}>
                <p>
                    Optimal Water Intake: <span className='water-intake-value' id="result"></span>
                </p>
            </div>
        </div>
    )
}

export default WiCalculator
